import { useMemo } from 'react';
import { NoticeModel, useInfiniteCategoryNotices } from '~/components/Support';

export const useWinnerNotices = (subCategory?: NoticeModel['subCategory']) => {
  const { data: { pages = [] } = {}, ...rest } = useInfiniteCategoryNotices('winners');
  const data: NoticeModel[] = useMemo(
    () =>
      pages.flatMap((page) =>
        page.documents.filter((document) => !subCategory || document.subCategory === subCategory)
      ),
    [pages, subCategory]
  );

  return {
    data,
    ...rest,
  };
};
